import { Link } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'
import LanguageSwitcher from './language-switcher'
import { FormattedMessage } from 'react-intl'
import { Context } from './context'
import { slide as Menu } from "react-burger-menu"
import { LienzoHeader
        ,MainTitle
        ,LienzoMenu
        ,Nav
        ,MenuLi
        ,MobileMenu
        ,MenuUl
        ,LinkMenu
       } from '../theme/globalStyle'
import { css } from "@emotion/core"

const ListLink = props => (
    <MenuLi>
        <Link to={props.to} css={LinkMenu}>
            {props.children}
        </Link>
    </MenuLi>
);

const sLink = css`
    color: #B30000;
    &:hover
`

class Header extends React.Component {

    callMenu = e => {
        this.isActive = !this.isActive;
        console.log(this.isActive);
    }

    render(){

        return(
            <Context.Consumer>
		        {({ toggleLanguage, lang }) => (
                    <>
                    <MobileMenu>
                        <Menu>
                            <Link className="menu-item" to="/" ><FormattedMessage id="menu-home" /></Link>
                            <Link className="menu-item" to="/blog" ><FormattedMessage id="menu-blog" /></Link>
                            <Link className="menu-item" to="/category" ><FormattedMessage id="menu-category" /></Link>
                            <Link className="menu-item" to="/podcast" ><FormattedMessage id="menu-podcast" /></Link>
                            <Link className="menu-item" to="/social-networks/" ><FormattedMessage id="menu-social-network" /></Link>
                            <Link className="menu-item" to="/acknowledgments/" ><FormattedMessage id="acknowledgments" /></Link>
                            <Link className="menu-item" to="/about" ><FormattedMessage id="about" /></Link>
                            <LanguageSwitcher lang={lang} toggleLanguage={toggleLanguage}/>
                        </Menu>
                    </MobileMenu>
                    <header>
                        <LienzoHeader>
                            <MainTitle>
                                <Link to={`/`} css={sLink}>
                                    <FormattedMessage id="title" />
                                </Link>
                            </MainTitle>
                        </LienzoHeader>
                        <LienzoMenu>
                            <Nav>
                                <MenuUl>
                                    <ListLink to="/"><FormattedMessage id="menu-home" /></ListLink>
                                    <ListLink to="/blog" ><FormattedMessage id="menu-blog" /></ListLink>
                                    <ListLink to="/category"><FormattedMessage id="menu-category" /></ListLink>
                                    <ListLink to="/podcast"><FormattedMessage id="menu-podcast" /></ListLink>
                                    <ListLink to="/social-networks/"><FormattedMessage id="menu-social-network" /></ListLink>
                                    <ListLink to="/acknowledgments/"><FormattedMessage id="acknowledgments" /></ListLink>
                                    <ListLink to="/about"><FormattedMessage id="about" /></ListLink>
                                    <LanguageSwitcher lang={lang} toggleLanguage={toggleLanguage}/>
                                </MenuUl>
                            </Nav>
                        </LienzoMenu>
                    </header>
                    </>
                )}
            </Context.Consumer>
        )
    }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: '',
}

export default Header;
